<template>
  <v-card
    :flat="!$vuetify.breakpoint.smAndUp"
    class="mb-3"
  >
    <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
      Notes for the Production Manager
    </v-card-title>
    <v-card-text :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
      <v-textarea
        :value="value.freelancerNotes"
        class="pt-0"
        auto-grow
        rows="2"
        @input="(val) => $emit('input', {
          ...value,
          freelancerNotes: val
        })"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style>

</style>
